module.exports = __webpack_public_path__ + "static/media/grosveinard.c0a2b97e.gif";